import { HttpErrorResponse } from '@angular/common/http';
import { OperatorFunction, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { parseSapError } from './parse-sap-error';

export const rethrowAsSapError = <T>(): OperatorFunction<T, T> =>
  catchError((err: unknown) => {
    if (err instanceof HttpErrorResponse) {
      // HttpErrorResponse.error is typed `any`; parseSapError narrows it defensively.
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      const sapError = parseSapError(err.error, err.status);

      return throwError(() => sapError);
    }

    return throwError(() => err);
  });
